// utils/excelUtils.js
export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = e.target.result;
        const workbook = parseCSV(data);
        resolve(workbook);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = () => {
      reject(new Error('파일을 읽는 중 오류가 발생했습니다.'));
    };
    
    // CSV 파일로 처리 (간단한 구현)
    reader.readAsText(file, 'UTF-8');
  });
};

const parseCSV = (csvText) => {
  const lines = csvText.split('\n').filter(line => line.trim());
  const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
  
  const data = lines.slice(1).map((line, index) => {
    const values = line.split(',').map(v => v.trim().replace(/"/g, ''));
    const row = {};
    
    headers.forEach((header, i) => {
      row[header] = values[i] || '';
    });
    
    // ID 추가 (없으면 자동 생성)
    row.id = row.id || Date.now() + index;
    
    return row;
  });
  
  return data;
};

export const validateProductData = (products) => {
  const requiredFields = ['name', 'category', 'unitPrice'];
  const errors = [];
  
  products.forEach((product, index) => {
    requiredFields.forEach(field => {
      if (!product[field] || product[field].toString().trim() === '') {
        errors.push(`${index + 2}행: ${field} 필드가 비어있습니다.`);
      }
    });
    
    // 단가가 숫자인지 확인
    if (product.unitPrice && isNaN(parseFloat(product.unitPrice))) {
      errors.push(`${index + 2}행: 단가는 숫자여야 합니다.`);
    }
  });
  
  return errors;
};

export const convertToProductFormat = (data) => {
  return data.map(row => ({
    id: Date.now() + Math.random(),
    name: row.name || row['품목명'] || row['제품명'] || '',
    category: row.category || row['카테고리'] || row['분류'] || '기타',
    unitPrice: parseFloat(row.unitPrice || row['단가'] || row['가격'] || 0),
    unit: row.unit || row['단위'] || '개',
    description: row.description || row['설명'] || row['비고'] || ''
  }));
};

export const generateSampleCSV = () => {
  // UTF-8 BOM 추가 (엑셀에서 한글 깨짐 방지)
  const BOM = '\uFEFF';
  const sampleData = `name,category,unitPrice,unit,description
노트북,전자제품,1200000,대,업무용 노트북
모니터,전자제품,300000,대,24인치 LED 모니터
복사용지,사무용품,5000,권,A4 복사용지
웹사이트 개발,서비스,2000000,건,반응형 웹사이트 개발`;
  
  const blob = new Blob([BOM + sampleData], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = '품목템플릿.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};